import { render, staticRenderFns } from "./mgmtPatients.vue?vue&type=template&id=059fd2e8&scoped=true&"
import script from "./mgmtPatients.vue?vue&type=script&lang=js&"
export * from "./mgmtPatients.vue?vue&type=script&lang=js&"
import style0 from "./mgmtPatients.vue?vue&type=style&index=0&id=059fd2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fd2e8",
  null
  
)

export default component.exports